import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doPostFiles, doPutFiles, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getSchemaProposalGranteeBasicInfo = (projectId) => {
  const url = `${API_ROOT}/proposal/${projectId}/grantee`
  return doGet(url)
}

export const saveProposalGranteeBasicInfo = (request, projectId) => {
  const url = `${API_ROOT}/proposal/${projectId}/grantee/personal`
  return doPostFiles(url, request)
}

export const updateProposalGranteeBasicInfo = (request, projectId, personalId) => {
  const url = `${API_ROOT}/proposal/${projectId}/grantee/personal/${personalId}`
  return doPutFiles(url, request)
}

export const saveProposalGranteeCompanyBasicInfo = (request, projectId) => {
  const url = `${API_ROOT}/proposal/${projectId}/grantee/company`
  return doPostFiles(url, request)
}

export const updateProposalGranteeCompanyBasicInfo = (request, projectId, companyId) => {
  const url = `${API_ROOT}/proposal/${projectId}/grantee/company/${companyId}`
  return doPutFiles(url, request)
}

export const downlondDocument = (projectId, filePath) => {
  const url = `${API_ROOT}/proposal/${projectId}/attachments/download?path=${filePath}`
  return doDownload(url)
}

//SubProject
export const getSchemaSubProjectProposalGranteeBasicInfo = (projectId) => {
  const url = `${API_ROOT}/subproject/${projectId}/grantee`
  return doGet(url)
}

export const saveSubProjectProposalGranteeBasicInfo = (request, projectId) => {
  const url = `${API_ROOT}/subproject/${projectId}/grantee/personal`
  return doPostFiles(url, request)
}

export const updateSubProjectProposalGranteeBasicInfo = (request, projectId, personalId) => {
  const url = `${API_ROOT}/subproject/${projectId}/grantee/personal/${personalId}`
  return doPutFiles(url, request)
}

export const saveSubProjectProposalGranteeCompanyBasicInfo = (request, projectId) => {
  const url = `${API_ROOT}/subproject/${projectId}/grantee/company`
  return doPost(url, request)
}

export const updateSubProjectProposalGranteeCompanyBasicInfo = (request, projectId, companyId) => {
  const url = `${API_ROOT}/subproject/${projectId}/grantee/company/${companyId}`
  return doPut(url, request)
}

export const downlondSubProjectDocument = (projectId, filePath) => {
  const url = `${API_ROOT}/subproject/${projectId}/attachments/download?path=${filePath}`
  return doDownload(url)
}
